import { useState } from 'react';

import { makePaymentBill, makePaymentSBP } from '../../../api/ans';
import cardMethodIcon from '../../../assets/images/cardMethod.svg';
import iconWarning from '../../../assets/images/icon-warning.svg';
import infoIcon from '../../../assets/images/infoicon.svg';
import invokeMethcoIcon from '../../../assets/images/invokeMethod.svg';
import sbpMethodIcon from '../../../assets/images/sbpMethod.svg';
import { getOwnerBalanceThunk } from '../../../store/slices/paymentsSlice';
import { closePopup, openPopup } from '../../../store/slices/popupSlice';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import {
  formatCurrency,
  pluralizeCargo,
  transformDocs,
  waitAndUpdateBalance,
} from '../../../utils/functions';
import useSubmitLock from '../../../utils/useSubmitLock';
import BankCardItemPayment from '../../BankCardItemPayment/BankCardItemPayment';
import Switcher from '../../Switcher/Switcher';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function PayMethodsLegalPopup() {
  const [loading, setLoading] = useState(false);
  const { isSubmitting, run } = useSubmitLock();
  const [selectedCard, setCard] = useState({});
  const cards = useAppSelector((state) => state.cards.cards);
  const user = useAppSelector((state) => state.user.data);
  const [valueSize, setValueSize] = useState('СБП');
  const dispatch = useAppDispatch();
  const popupProps = useAppSelector((state) => state.popup.popupProps);
  const total = popupProps?.info?.services?.total;
  const servicesList = popupProps?.info?.services?.details;
  const context = popupProps?.context;
  const res = popupProps?.info;
  console.log(popupProps);
  const services = transformDocs(servicesList);
  console.log(services);
  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  async function startPayment() {
    if (valueSize === 'СБП') {
      await makePaymentSBP({
        amount: context === 'services' ? total : res?.need_to_pay,
        pay_type: context === 'services' ? 'services' : 'storage',
      })
        .then((value) => {
          window.open(value.QrUrl, '_blank');
          console.log('✅ Успешно:', value);
          dispatch(getOwnerBalanceThunk(user.id));
          const ok = waitAndUpdateBalance(user.id, dispatch, 10);
          if (ok) dispatch(closePopup('otherPayments'));
          else console.warn('⚠ Баланс не обновился вовремя');
          dispatch(closePopup('otherPayments'));
        })
        .catch((error) => {
          console.error('❌ Ошибка при оплате:', error);

          // Проверяем тип ошибки — отмена пользователем или сбой сети
          if (error?.message?.toLowerCase().includes('cancel')) {
            console.warn('Пользователь отменил оплату');
          } else {
            alert('Произошла ошибка при оплате. Пожалуйста, попробуйте снова.');
          }
        });
    } else if (valueSize === 'Картой') {
      dispatch(
        openPopup({
          name: 'paymentMethods',
          props: {
            context,
            amount: context === 'services' ? total : res?.need_to_pay,
          },
        })
      );
    } else {
      setLoading(true);
      await makePaymentBill({
        amount: context === 'services' ? total : res?.need_to_pay,
        pay_type: context,
      })
        .then((value) => {
          console.log(value);
          window.open(value.filepath);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Ошибка при создании счёта:', error);
          setLoading(false);
          dispatch(openPopup('topUpFail'));
        });
    }
  }

  // Повторный клик, пока платёж или счёт создаётся, игнорируется
  function handlePay() {
    return run(startPayment);
  }

  return (
    <div className={styles.topUpBalancePopupWrapper}>
      <div>
        <h4 className={styles.header}>
          {context === 'storage' ? 'Оплата хранения' : 'Оплата дополнительных услуг'}
        </h4>
        <button
          className={styles.closePopupButton}
          onClick={handleClosePopup}
          aria-label="Закрыть"
        />
      </div>
      <div className={styles.servicesWrapper}>
        {context === 'services' ? (
          services.map((item, index) => (
            <div key={index} className={styles.listServices}>
              <div className={styles.beginRow}>
                <span className={styles.docNum}>{item.doc_no}</span>
                <span className={styles.line} />
              </div>
              <div className={styles.serviceCount}>
                <span>Количество услуг</span>
                <span>{item.servicesCount}</span>
              </div>
              <div className={styles.serviceCount}>
                <span>Общая стоимоть</span>
                <span>{`${formatCurrency(item.totalAmount)} ₽`}</span>
              </div>
            </div>
          ))
        ) : (
          <div className={styles.listServices}>
            <div className={styles.serviceCount}>
              <span>{pluralizeCargo(res?.qty)}</span>
              <span>{Number(res?.stored_goods_volume).toFixed(2)}</span>
            </div>
            <div className={styles.serviceCount}>
              <span>Период оплаты</span>
              <span>1 месяц</span>
            </div>
            <div className={styles.serviceCount}>
              <span>Стоимость в месяц</span>
              <span>{res?.monthly_payment}</span>
            </div>
          </div>
        )}
        <div className={styles.resultAmount}>
          <span className={styles.line} />
          <div className={styles.resultAmountText}>
            <span>Итого к оплате</span>
            <span>{`${context === 'services' ? formatCurrency(total) : formatCurrency(res?.need_to_pay)} ₽`}</span>
          </div>
        </div>
      </div>
      <div className={styles.paySection}>
        <div className={styles.resultAmountText}>
          <span>Итого к оплате</span>
        </div>
        <Switcher
          options={[
            { label: 'СБП', value: 'СБП', src: sbpMethodIcon },
            { label: 'Картой', value: 'Картой', src: cardMethodIcon },
            { label: 'По счету', value: 'По счету', src: invokeMethcoIcon },
          ]}
          value={valueSize}
          onChange={setValueSize}
          type="popup"
        />
        {valueSize === 'СБП' ? (
          <div className={styles.warningBlock}>
            <img src={iconWarning} alt="Внимание" />
            <span>Можно оплачивать только бизнес-картой</span>
          </div>
        ) : valueSize === 'Картой' ? (
          <div className={styles.bankCardsContainer}>
            {cards.map((card) => (
              <BankCardItemPayment
                key={card.id}
                card={card}
                setCard={setCard}
                isSelected={card.id === selectedCard.id}
              />
            ))}
            <div className={styles.infoBlock}>
              <img src={infoIcon} alt="Внимание" />
              <span>Убедитесь, что вы используете бизнес-карту</span>
            </div>
          </div>
        ) : (
          <div className={styles.servicesWrapper}>
            <div className={styles.serviceCount}>
              <span>Плательщик</span>
              <span>{user?.company_name}</span>
            </div>
            <div className={styles.serviceCount}>
              <span>ИНН</span>
              <span>{user?.inn}</span>
            </div>
          </div>
        )}
        <RedButton
          text={
            valueSize === 'По счету'
              ? 'Сформировать счёт'
              : context === 'storage'
                ? 'Оплата хранения'
                : 'Оплатить услуги'
          }
          height={50}
          disabled={
            (context === 'services' && total === 0) ||
            (context === 'storage' && res?.need_to_pay === 0)
          }
          onClick={() => {
            handlePay();
          }}
          loading={loading || isSubmitting}
        />
      </div>
    </div>
  );
}

export default PayMethodsLegalPopup;
